module.exports = __webpack_public_path__ + "img/sunrise.b8d5d7cd.svg";